import { Button as PrimeButton } from 'primereact/button';
import type { ButtonProps as PrimeButtonProps } from 'primereact/button';
import { Icon, piIconName } from '../../components/common/icon';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'help'
  | 'outlined'
  | 'text';

export interface ButtonProps extends Omit<PrimeButtonProps, 'ref'> {
  /** Adds a data-testid attribute for e2e/testing selectors. */
  testId?: string;
  /** Convenience alias that maps to PrimeReact severity / outlined / text. */
  variant?: ButtonVariant;
}

export const Button = ({ testId, variant, severity, outlined, text, icon, ...props }: ButtonProps) => {
  let resolvedSeverity = severity;
  let resolvedOutlined = outlined;
  let resolvedText = text;

  if (variant === 'outlined') {
    resolvedOutlined = true;
  } else if (variant === 'text') {
    resolvedText = true;
  } else if (variant && variant !== 'primary') {
    resolvedSeverity = variant as PrimeButtonProps['severity'];
  }

  // A legacy `icon="pi pi-*"` becomes a Lucide element (PrimeReact renders an
  // element icon with the right spacing); a spinner or unmapped class passes
  // through unchanged, so loaders still spin and nothing goes missing.
  const mapped = typeof icon === 'string' ? piIconName(icon) : undefined;
  const resolvedIcon = mapped ? <Icon name={mapped} size={16} /> : icon;

  return (
    <PrimeButton
      {...({ 'data-testid': testId } as any)}
      severity={resolvedSeverity}
      outlined={resolvedOutlined}
      text={resolvedText}
      icon={resolvedIcon as PrimeButtonProps['icon']}
      {...props}
    />
  );
};

export default Button;
